import countries from 'i18n-iso-countries'
import enLocale from 'i18n-iso-countries/langs/en.json'

countries.registerLocale(enLocale)

export interface CountryOption {
  code: string
  name: string
}

// ISO-3166 alpha-2 code + English name, alphabetised by name for the dropdown.
export const COUNTRY_OPTIONS: CountryOption[] = Object.entries(
  countries.getNames('en')
)
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name))
